/* eslint-disable react/no-array-index-key */
import React from "react"

import { Obj, connect } from "scrivito"
import { stopPropagationAndPreventDefault } from "shared/lib/stopPropagation"
import { times } from "shared/lib/times"
import { BreadcrumbItem } from "shared/ui/breadcrumb/BreadcrumbItem"
import { BreadcrumbWrapper } from "shared/ui/breadcrumb/BreadcrumbWrapper"

import { ScrivitoPageBreadcrumbItem } from "./ScrivitoPageBreadcrumbItem"

const IGNORED_OBJECT_CLASSES: string[] = []

interface ScrivitoBreadcrumbProps {
  page?: Obj | null | undefined
  loadingItemAmount?: number
  isLoading?: boolean
  ignoredObjClasses?: string[]
}

export function ScrivitoPageBreadcrumbComponent({
  page,
  loadingItemAmount = 4,
  ignoredObjClasses = IGNORED_OBJECT_CLASSES
}: ScrivitoBreadcrumbProps) {
  return (
    <BreadcrumbWrapper>
      {page
        ?.ancestors()
        .map((obj, index) =>
          obj ? (
            <ScrivitoPageBreadcrumbItem
              key={obj?.id()}
              obj={obj}
              ignoredObjClasses={ignoredObjClasses}
            />
          ) : (
            <BreadcrumbItem key={index} isLoading />
          )
        )}
      {!page ? (
        times(loadingItemAmount).map(num => (
          <BreadcrumbItem
            key={num}
            isLoading
            isActive={loadingItemAmount === num}
          />
        ))
      ) : (
        <li className="breadcrumb-item active" data-testid="breadcrumb-item">
          <a
            href=""
            aria-current="page"
            className="link"
            onClick={stopPropagationAndPreventDefault}
          >
            {(page.get("navigationTitle") || page.get("title")) as string}
          </a>
        </li>
      )}
    </BreadcrumbWrapper>
  )
}

export const ScrivitoPageBreadcrumb = React.memo(
  connect(ScrivitoPageBreadcrumbComponent)
)
